import React from 'react';
import { Section } from './ui/Section';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  const learnings = ['Why your brain saves the worst thoughts for bedtime', "How to stop the 'Responsible Woman Spiral' (planning ≠ peace)", 'A 4-phase method that teaches your nervous system to expect calm', 'The exact protocol for 2–4am wake-ups', 'A done-for-you 7-day plan that builds consistency', 'Troubleshooting for stress days, travel, and hormonal weeks'];
  return <Section dark={false} className="bg-cream-50" data-id="element-174">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-175">
        <span className="text-gold-600 font-bold tracking-widest uppercase text-xs mb-4 block" data-id="element-176">
          Introducing
        </span>
        <h2 className="text-4xl md:text-5xl font-serif text-navy-900 mb-6" data-id="element-177">
          The Sleep & Serenity Blueprint <br data-id="element-178" />
          <span className="italic text-navy-700" data-id="element-179">for Women 40+</span>
        </h2>
        <p className="text-xl text-navy-700/80 leading-relaxed" data-id="element-180">
          A practical, non-woo guide to end nightly anxiety loops and reclaim
          deep sleep—without meds, extreme routines, or perfect days.
        </p>
      </div>

      <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-cream-200 max-w-4xl mx-auto" data-id="element-181">
        <h3 className="text-2xl font-serif text-navy-900 mb-8 text-center" data-id="element-182">
          What you'll learn in this blueprint
        </h3>
        <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-183">
          {learnings.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-184">
              <div className="flex-shrink-0 mt-1" data-id="element-185">
                <div className="w-6 h-6 rounded-full bg-gold-100 flex items-center justify-center" data-id="element-186">
                  <CheckIcon className="w-4 h-4 text-gold-600" data-id="element-187" />
                </div>
              </div>
              <p className="text-navy-800 leading-snug" data-id="element-188">{item}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}